var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_header",style:(_vm.cssVars)},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"inner"},[(_vm.title)?_c('h1',{domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.parsedCta)?_c('a',{attrs:{"href":_vm.parsedCta.url,"title":_vm.parsedCta.title,"target":_vm.parsedCta.target},domProps:{"innerHTML":_vm._s(_vm.parsedCta.title)}}):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/clarencelifts.stagingwebsite.dev/web/app/themes/clarence-lifts/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/clarencelifts.stagingwebsite.dev/web/app/themes/clarence-lifts/node_modules/vue-loader/lib?{}!./scripts/vue/PageHeader.vue?vue&type=template&id=7f233e00&scoped=true&
// module id = 117
// module chunks = 0